import React, { type ReactNode, useMemo } from 'react'

import { limit, orderBy, query } from 'firebase/firestore'

import { useMultipleQueryData } from '@/firestore/useMultipleQueryData.ts'

import { teamLocationCollection, type TeamLocationSnapshotData } from '../firestore/teamLocationCollection.ts'

import { useTeams } from './useTeams.ts'

export type TeamsLatestLocationContextValue = Record<string, TeamLocationSnapshotData>

export const TeamsLatestLocationContext = React.createContext<TeamsLatestLocationContextValue>({})

export const TeamsLatestLocationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { teams } = useTeams()
  const teamIds = useMemo(() => teams.filter((t) => t.status !== 'DISSOLVED').map(({ _id }) => _id), [teams])
  const state = useMultipleQueryData({
    keys: teamIds,
    collectionName: 'teams.locations',
    queryFn: (id) => query(teamLocationCollection(id), orderBy('timestamp', 'desc'), limit(1)),
    dataFn: (snapshot) => (snapshot.empty ? undefined : snapshot.docs[0].data()),
  })

  return <TeamsLatestLocationContext.Provider value={state}>{children}</TeamsLatestLocationContext.Provider>
}
